import { useState, useEffect } from 'react';
import type { ReactNode, MouseEvent } from 'react';
import { Checkbox } from '@/components/Checkbox';
import Toggle from '@/components/Toggle';
import { FILTER_TYPE } from '../../constants';
import { Transition } from 'react-transition-group';
import {
  Accordion,
  AccordionHeader,
  ChildContainer,
  Label,
  SubLabel,
} from './styled';

const getLabelRender = (
  label: string,
  subLabel?: string,
  formattedValue = ''
) => (
  <Label>
    {label} {subLabel && <SubLabel>{subLabel}</SubLabel>} {formattedValue}
  </Label>
);

interface Props {
  label: string;
  subLabel?: string;
  formattedTitle?: string;
  children: ReactNode;
  onToggle: () => void;
  toggled?: boolean;
  type?: string;
}

// TODO: restyled Checkbox to work without the need for AccordionHeaderLabel. This means only 1 click controls the toggle
const CollapsibleCheck = ({
  label,
  subLabel,
  formattedTitle,
  children,
  type,
  onToggle = () => null,
  toggled = false,
}: Props) => {
  const [isInitialRender, setInitialRender] = useState(true);
  useEffect(() => {
    setInitialRender(false);
  }, []);

  const getChildVisibility = () => {
    if (isInitialRender && toggled) return true;
    return toggled && type !== FILTER_TYPE.TOGGLE;
  };

  const getChildState = (state: string) => {
    return isInitialRender && toggled ? 'entered' : state;
  };

  const toggleDuration = 140;

  return (
    <Accordion>
      <AccordionHeader
        toggled={type !== FILTER_TYPE.TOGGLE && toggled}
        onClick={(e: MouseEvent) => {
          const { nodeName } = e.target as HTMLDivElement;
          /** only fire event when clicking on div */
          if (nodeName.toLowerCase() === 'div') {
            onToggle();
          }
        }}
      >
        {type === FILTER_TYPE.TOGGLE ? (
          <Toggle
            name={label}
            value={toggled || false}
            displayType={'block'}
            invert={true}
            label={getLabelRender(label, subLabel)}
            onChange={onToggle}
            trackingProps={{
              modifier: 'item',
              label,
            }}
          />
        ) : (
          <Checkbox
            display={'block'}
            invert
            trackingProps={{
              modifier: 'item',
              label,
            }}
            value={toggled || false}
            disabled={false}
            readOnly={true}
            plusAndTick={true}
            onChange={onToggle}
            label={getLabelRender(
              label,
              subLabel,
              toggled ? formattedTitle : ''
            )}
          />
        )}
      </AccordionHeader>
      <Transition in={getChildVisibility()} timeout={toggleDuration}>
        {(state) => (
          <ChildContainer
            duration={toggleDuration}
            state={getChildState(state)}
          >
            {children}
          </ChildContainer>
        )}
      </Transition>
    </Accordion>
  );
};

export default CollapsibleCheck;
